<div [ngClass]="wrapperClass">
  @if (control) {
    <div class="selections">
      <div [ngClass]="getSelectorClasses()"></div>
      @for (option of options; track option; let i = $index) {
        <input
          type="radio"
          name="{{ groupName }}"
          value="{{ option.value }}"
          [checked]="control.value === option.value"
          (click)="select(option.value)"
          [disabled]="option.disabled"
          id="{{ groupName + '_' + i.toString() }}"
          class="rbHide"
          />
      }
      @for (option of options; track option; let i = $index) {
        <div [ngClass]="getItemClass(option)" (click)="!option.disabled && select(option.value)">
          <label for="{{ groupName + '_' + i.toString() }}" [ngClass]="getLabelClass(option)">
            {{ option.name | translate }}
          </label>
        </div>
      }
    </div>
  }
</div>
